export default angular.module("khFileUploads", ["ngCookies"]);